import styled from 'styled-components';
import tw from 'twin.macro';
import resolveConfig from 'tailwindcss/resolveConfig';

import tailwindConfig from '../../tailwind.config';

const fullConfig = resolveConfig(tailwindConfig);

export const MovieDetailsStyled = styled.div`
  ${tw`mr-5`}
  max-width: 856px;

  h2 {
    ${tw`text-white text-3xl font-bold mb-6 my-6`}
    font-size: 32px;
  }
`;

export const DetailStyled = styled.div`
  ${tw`flex `}

  h4 {
    ${tw`text-white font-bold`}
    width: 200px;
  }

  ul {
    ${tw`flex mt-2`};
    margin-top: 6px !important;
    flex-direction: column;

    @media (min-width: ${fullConfig.theme.screens.lg}) {
      flex-direction: row;

      li {
        &:first-child {
          &:before {
            display: none;
          }
        }
      }
    }

    li {
      ${tw`text-base text-white text-blue-300 text-white font-normal pr-3 flex items-center `};
      color: white !important;
      margin-bottom: 0 !important;

      &:before {
        ${tw`bg-white rounded-full h-1 w-1 mr-3`};
        content: '';
        background: white !important;
      }
    }
  }
`;
